import IVerifyCnpjAvailabilityRequest from '../entities/VerifyCnpjAvailabilityRequest'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IVerifyCnpjAvailability {
  execute(params: IVerifyCnpjAvailabilityRequest): Promise<void>
}

export default class VerifyCnpjAvailabilityImpl
  implements IVerifyCnpjAvailability
{
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: IVerifyCnpjAvailabilityRequest): Promise<void> {
    await this.userRepository.verifyCnpjAvailability(params)
  }
}
